import { jsx } from "react/jsx-runtime";
import "react";
import { useFormContext } from "react-hook-form";
import PaymentDonutChart from "../PaymentDonutChart/PaymentDonutChart.esm.js";
import { useLastValidAffordabilityValues } from "./AffordabilityCalculator.utils.esm.js";
function AffordabilityChart() {
  const form = useFormContext();
  const lastValidValues = useLastValidAffordabilityValues(form);
  const taxes = lastValidValues.calculations.affordability.affordabilityByDTI * (lastValidValues.fields.propertyTaxRate / 100) / 12;
  const insurance = lastValidValues.fields.annualHomeownersInsurance / 12;
  const chartDataProps = {
    monthlyPayment: lastValidValues.calculations.affordability.monthlyPayment,
    monthlyPI: lastValidValues.calculations.pi,
    monthlyPropertyTax: lastValidValues.fields.includeTaxesInsurance ? taxes : 0,
    monthlyHomeownersInsurance: lastValidValues.fields.includeTaxesInsurance ? insurance : 0,
    monthlyPMI: lastValidValues.fields.includePMI ? lastValidValues.calculations.pmi : 0,
    monthlyHOA: lastValidValues.fields.monthlyHOA
  };
  return /* @__PURE__ */ jsx(PaymentDonutChart, { ...chartDataProps });
}
export {
  AffordabilityChart as default
};
